import { dmnStorage } from "../dmnStorage";

export type RunsheetColumnsType = {
  type: boolean;
  labels: boolean;
  phone: boolean;
  requests: boolean;
};

export type RunsheetGroupBy = "time" | "quarter" | "hour";

export type RunsheetConfigDataStorageType = {
  showTimeDividers: boolean;
  showHeaderRow: boolean;
  columns: RunsheetColumnsType;
  /** How bookings are bucketed under time dividers. */
  groupBy: RunsheetGroupBy;
};

export const runsheetConfigStorageDefault: RunsheetConfigDataStorageType = {
  showTimeDividers: true,
  showHeaderRow: true,
  columns: { type: true, labels: true, phone: true, requests: true },
  groupBy: "time"
};

export const getRunsheetConfigFromStorage =
  async (): Promise<RunsheetConfigDataStorageType> => {
    const stored: Partial<RunsheetConfigDataStorageType> | null | undefined =
      await dmnStorage.get("runsheetConfig");
    // Merge over the defaults so configs saved before new fields existed pick
    // up those fields' defaults.
    return {
      ...runsheetConfigStorageDefault,
      ...stored,
      columns: {
        ...runsheetConfigStorageDefault.columns,
        ...stored?.columns
      }
    };
  };

export const setRunsheetConfigToStorage = async (
  runsheetConfig: RunsheetConfigDataStorageType
): Promise<void> => {
  await dmnStorage.add("runsheetConfig", runsheetConfig);
};
